exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.common-link[data-v-0f9a189a] {\r\n  color: #428bca;\n}\n.common-link[data-v-0f9a189a]:active {\r\n  color: lightskyblue;\n}\n.icon-mail-box[data-v-0f9a189a] {\r\n  width: 25px;\r\n  margin-left: 5px;\n}\n.icon-mail[data-v-0f9a189a] {\r\n  width: 22px;\r\n  position: absolute;\r\n  top: 50%;\r\n  -webkit-transform: translateY(-50%);\r\n          transform: translateY(-50%);\n}\n.icon-badge[data-v-0f9a189a] {\r\n  right: -5px;\r\n  top: -3px;\r\n  position: absolute;\n}\r\n", ""]);

// exports
